{
  "changes": {
    "added": "neu",
    "modified": "geändert",
    "removed": "entfernt",
    "unchanged": "unverändert"
  },
  "impact": {
    "absent": "Keine Belege aus akzeptierten gespeicherten Durchläufen auf den geänderten Dokumenten. Erwartete Durchläufe prüfen.",
    "acknowledge": "Ich habe die geänderten und entfernten Anker gesichtet und bestätige ihre Auswirkungen.",
    "acknowledgementNote": "Bestätigung der Auswirkungen: Was braucht als Nächstes ein Review?",
    "carried_one": "Fortführung abgeschlossen: {{count}} Entscheidung angewendet. Fortgeführte Revisionen sind Vorschläge zum Review.",
    "carried_other": "Fortführung abgeschlossen: {{count}} Entscheidungen angewendet. Fortgeführte Revisionen sind Vorschläge zum Review.",
    "carry": "Unveränderte und verschobene Anker fortführen ({{count}})",
    "checkState": "Serverstatus prüfen",
    "decisions": {
      "carry_forward": "fortgeführt",
      "keep_historical": "historisch beibehalten",
      "re_review": "erneut ins Review",
      "re_run": "erneut ausführen",
      "withdraw": "zurückgezogen"
    },
    "documentsChanged_one": "{{count}} geändertes oder entferntes Dokument",
    "documentsChanged_other": "{{count}} geänderte oder entfernte Dokumente",
    "findings": "Alle abhängigen Anker ({{count}})",
    "mergeConfirmed": "Der Server bestätigt, dass dieser Import übernommen wurde.",
    "merged": "Import übernommen.",
    "needsAttention": "Braucht eine einzelne Durchsicht; dieser Anker kann nicht gesammelt fortgeführt werden.",
    "notResubmitted": "Einmal gesendet. Der Server arbeitet möglicherweise noch; Status unten prüfen.",
    "outcomes": {
      "changed": "geändert",
      "moved": "verschoben",
      "removed": "entfernt",
      "unchanged": "unverändert"
    },
    "recorded_one": "{{count}} Fortführungsentscheidung erfasst; {{remaining}}.",
    "recorded_other": "{{count}} Fortführungsentscheidungen erfasst; {{remaining}}.",
    "remaining_one": "{{count}} geeigneter Anker verbleibt",
    "remaining_other": "{{count}} geeignete Anker verbleiben",
    "stale": "Der Auswirkungsbericht gehört zu einer anderen Version des Vorschlags. Laden Sie dieses Review vor der Übernahme neu.",
    "stillOpen": "Bei der letzten Abfrage war der Änderungssatz noch offen. Die Anfrage läuft möglicherweise noch.",
    "summary": "{{documents}}. Beleganker gespeicherter Durchläufe: {{changed}} geändert, {{unchanged}} unverändert, {{moved}} verschoben, {{removed}} entfernt.",
    "title": "Auswirkungen auf gespeicherte Durchläufe und andere Abhängigkeiten",
    "working": "In Bearbeitung ({{seconds}} s vergangen). Lassen Sie dieses Review geöffnet."
  },
  "list": {"title": "Korpusimporte"},
  "page": {
    "addedText_one": "{{count}} Zeichen eingefügt",
    "addedText_other": "{{count}} Zeichen eingefügt",
    "after": "Nachher",
    "before": "Vorher",
    "columns": {
      "change": "Änderung",
      "characters": "Zeichen",
      "document": "Dokument",
      "pages": "Seiten",
      "segments": "Segmente"
    },
    "corpusMoved": "Das Korpus hat eine neuere Version als die, für die dieser Import geplant wurde; er kann nicht übernommen werden. Verwerfen Sie ihn und führen Sie den Import erneut aus.",
    "counts": "{{added}} hinzugefügt | {{modified}} geändert | {{removed}} entfernt | {{unchanged}} unverändert",
    "decision": "Ihre Entscheidung als Kuratorin oder Kurator des Korpus",
    "diffContext": "{{prefix}} unveränderte Zeichen davor; {{suffix}} danach",
    "documentText": "Ganzer Dokumenttext",
    "documents_one": "{{count}} Dokument",
    "documents_other": "{{count}} Dokumente",
    "fileStays": "Quelldatei auf dem PC, auf dem der Import läuft; Prüfsumme mit diesem Import erfasst.",
    "importFile": "Importdatei",
    "inspectSegments": "Segmente ansehen",
    "into": "Import in {{corpus}}",
    "madeIn": "Erstellt vom Werkzeuglauf in",
    "merge": "Übernehmen: neue Korpusversion",
    "next": "Weiter",
    "pagination": "Seiten der Änderungsliste",
    "previous": "Zurück",
    "provenance": "Woher die Dokumente stammen",
    "range": "{{start}}–{{end}} von {{total}}",
    "reason": "Begründung",
    "removedText_one": "{{count}} Zeichen entfernt",
    "removedText_other": "{{count}} Zeichen entfernt",
    "runtime": "Laufzeit",
    "scrap": "Verwerfen",
    "segmentationChanged": "Der Import ändert auch die Segmentierung des Korpus.",
    "sourceFile": "Quelldatei",
    "tool": "Werkzeug"
  }
}
